module.exports = __webpack_public_path__ + "media/images/wedding/thumb/21-e36ae3fc8ca284cbeea156104d793d2f.jpg";